import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '../components/ui/badge';
import { SectionHeader } from '../components/common/SectionHeader';
import { CTASection } from '../components/common/CTASection';
import { SectorsCarousel } from '../components/common/SectorsCarousel';
import { GeometricBackground } from '../components/decorations/GeometricBackground';
import { clientSectors } from '../data/company';
import { Building2, Heart, GraduationCap, Home, Landmark, Globe, Radio, Plane, Users } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const iconMap = {
  Building2,
  Heart,
  GraduationCap,
  Home,
  Landmark,
  Globe,
  Radio,
  Plane,
  Users,
};

const ClientsPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-hero-pattern overflow-hidden">
        <GeometricBackground />
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto text-center"
          >
            <Badge className="mb-4 bg-primary-foreground/10 text-primary-foreground border-primary-foreground/20">
              Valued Clients
            </Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-6">
              Industries We Serve
            </h1>
            <p className="text-lg text-primary-foreground/80">
              Our tailored ICT solutions are designed, installed, and commissioned across diverse sectors throughout Uganda and beyond.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sectors Carousel */}
      {/* <section className="section-padding bg-background">
        <div className="container-custom">
          <SectionHeader
            subtitle="Our Reach"
            title="Serving Diverse Industries"
            description="From commercial enterprises to government institutions, we deliver technology solutions that meet the unique needs of each sector."
            className="mb-12"
          />
          <SectorsCarousel sectors={clientSectors} />
        </div>
      </section> */}

      {/* Sectors Grid */}
      <section className="section-padding bg-background">
        <div className="container-custom">
          <SectionHeader
            subtitle="Our Reach"
            title="Serving Diverse Industries"
            description="From commercial enterprises to government institutions, we deliver technology solutions that meet the unique needs of each sector."
            className="mb-16"
          />

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {clientSectors.map((sector, index) => {
              const IconComponent = iconMap[sector.icon] || Building2;
              return (
                <motion.div
                  key={sector.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                >
                  <Card className="h-full hover:shadow-lg hover:border-primary/30 transition-all">
                    <CardContent className="p-6">
                      <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                        <IconComponent className="w-7 h-7 text-primary" />
                      </div>
                      <h3 className="text-lg font-semibold text-foreground mb-2">
                        {sector.name}
                      </h3>
                      <p className="text-muted-foreground">
                        {sector.description}
                      </p>
                    </CardContent>
                  </Card>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="section-padding bg-card">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
                Trusted Across Uganda and Beyond
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Our commitment to excellence has earned us the trust of organizations across various sectors. From multinational corporations to local businesses, from government agencies to NGOs, we deliver technology solutions that drive success and empower communities.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <CTASection
        title="Join Our Client Portfolio"
        description="Let's discuss how Voitech Solutions can help your organization achieve its technology goals."
        primaryButtonText="Get in Touch"
        primaryButtonLink="/contact"
      />
    </div>
  );
};

export default ClientsPage;
